import { useCallback, useEffect, useMemo, useState } from 'react';
import { creerClient, type Client } from '../../api/client.js';
import type { Ecran } from '../../api/contrat.js';
import { ETAT_CHARGEMENT, type EtatRequete } from '../../api/requete.js';
import { chargerEspaceClerc, apresDepot, apresMarquage, type DonneesClerc, type FichierADeposer } from './chargement.js';
import { VueEspaceClerc } from './VueClerc.js';
import { styleSecondaire } from './commun.js';
import { useClientExterne } from './contexte.js';

const aujourdhui = (): string => new Date().toISOString().slice(0, 10);

/** Espace de la clerc (X11) : charge ses lectures déclarées au contrat, écrit par les routes auditées. */
export function EspaceClerc(_props: { ecran: Ecran }) {
  const fourni = useClientExterne();
  const client: Client = useMemo(() => fourni ?? creerClient({ fetch: (...a) => globalThis.fetch(...a) }), [fourni]);
  const [etat, setEtat] = useState<EtatRequete<DonneesClerc>>(ETAT_CHARGEMENT as EtatRequete<DonneesClerc>);
  const [message, setMessage] = useState<string | null>(null);

  const recharger = useCallback(async () => setEtat(await chargerEspaceClerc(client)), [client]);
  useEffect(() => {
    void recharger();
  }, [recharger]);

  const onMarquer = async (index: number, statut: 'envoyee' | 'revenue') => {
    const r = await apresMarquage(client, etat, index, statut, aujourdhui());
    if (r.message === null) return;
    setMessage(r.message);
    setEtat(r.etat);
  };

  const onDeposer = async (fichier: FichierADeposer) => {
    const r = await apresDepot(client, (...a) => globalThis.fetch(...a), etat, fichier);
    if (r.message !== null) setMessage(r.message);
  };

  return (
    <>
      <VueEspaceClerc etat={etat} onMarquer={(i, s) => void onMarquer(i, s)} onDeposer={(f) => void onDeposer(f)} />
      {message ? (
        <p role="status" style={styleSecondaire}>
          {message}
        </p>
      ) : null}
    </>
  );
}
